import React from 'react';

function Navigation({ activeTab, setActiveTab }) {
  const tabs = [
    { id: 'settings', label: '営業時間/休日設定' },
    { id: 'reservation-toggle', label: '予約機能ON/OFF' },
    { id: 'reservations-list', label: '予約管理(一覧管理)' },
    { id: 'reservations', label: '予約管理(時間管理)' },
    { id: 'hero', label: 'カルーセル管理' },
    { id: 'menu', label: 'メニュー管理' },
    { id: 'kodawari', label: 'こだわり管理' },
    { id: 'seasonal', label: '旬のおすすめ管理' },
    { id: 'store-photos', label: '店舗写真管理' },
    { id: 'analytics', label: '分析' },
  ];

  return (
    <nav className="admin-nav">
      <div className="container">
        {tabs.map((tab) => (
          <a
            key={tab.id}
            href={`#${tab.id}`}
            className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              setActiveTab(tab.id);
            }}
          >
            {tab.label}
          </a>
        ))}
      </div>
    </nav>
  );
}

export default Navigation;

